module.exports = __webpack_public_path__ + "static/media/icon_fileimport_w.67cf7879.svg";